module.exports = __webpack_public_path__ + "static/media/labs.56e0b366.png";